export default "__VITE_ASSET__CiKCzktD__"